import { action } from 'typesafe-actions';

import { Company } from 'models/company';
import { Response } from 'models/response';
export const COMPANY_BILLING_SAVE = 'COMPANY_BILLING_SAVE';

export const COMPANY_BILLING_REQUEST = 'COMPANY_BILLING_REQUEST';
export const COMPANY_BILLING_SUCCESSFUL = 'COMPANY_BILLING_SUCCESSFUL';
export const COMPANY_BILLING_FAILURE = 'COMPANY_BILLING_FAILURE';

export const companyBillingSave = () => action(COMPANY_BILLING_SAVE);

export const companyBillingRequest = () => action(COMPANY_BILLING_REQUEST);

export const companyBillingSuccessful = ({ data }: Response<Company>) =>
  action(COMPANY_BILLING_SUCCESSFUL, { company: data });

export const companyBillingError = (error: string) => action(COMPANY_BILLING_FAILURE, error);
